<template>
	<div id="app" ondragstart="return false">
		<div class="beij" v-if="show">

		</div>
		<div class="tanchuang" v-if="show">
			<div class="atitles">
				<div class="atitle">
					<img src="./assets/gan.png" />提示
				</div>
			</div>
			<div class="contro">
				{{msg}}
			</div>
			<div class="gos">
				<el-button type="primary" @click="gologin">重新登录</el-button>
			</div>
		</div>
		<!-- <router-view/> -->
		<router-view v-if="isRouterAlive"></router-view>
	</div>
</template>

<script>
	// import f from './components/store/typesetting/typesetting2.vue'
	export default {
		name: 'App',
		provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
			return {
				reload: this.reload
			}
		},
		// components:{
		// 	f
		// },
		data() {
			return {
				isRouterAlive: true,
				show: false,
				times: [],
				msg: "暂无标题"
			}
		},
		created() {
			// setInterval(()=>{
			// 	this.getlogin()
			// },5000)
		},
		methods: {
			reload() {
				this.isRouterAlive = false; //先关闭，
				this.$nextTick(function() {
					this.isRouterAlive = true; //再打开
				})
			},
			getlogin() {
				if (localStorage.getItem("Authorization")) {
					this.$http.post("checkKickout").then(function(res) {
						if (res.body.code == 402) {
							this.msg = res.body.msg
							this.$http.post("kickoutCall").then(function(res) {
								console.log(res)
								if (res.body.code == 200) {
									localStorage.removeItem("Authorization")
									this.show = true
								}
							})
						}
					})
				}
			},
			gologin() {
				this.show = false
				this.$router.push({
					path: "login"
				})
			}
		}
	}
</script>

<style>
	.atitles {
		width: 100%;
		position: relative;
	}

	.atitle {
		margin-top: 10px;
		display: inline-block;
		margin-left: 40%;
		font-size: 24px;
	}

	.atitle>img {
		margin-right: 15px;
		position: relative;
		top: 6px;
		width: 35px;
	}

	#app {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.beij {
		z-index: 100;
		position: absolute;
		/* opacity: 0.8; */
		background-color: rgba(47, 47, 47, 0.5);
		width: 100%;
		height: 100%;
	}

	.tanchuang {
		z-index: 101;
		width: 35%;
		height: 220px;
		position: absolute;
		background-color: white;
		left: 50%;
		top: 50%;
		margin-top: -105px;
		margin-left: -17.5%;
	}

	.contro {
		margin: auto;
		width: 80%;
		text-align: center;
		font-size: 24px;
		margin-top: 20px;
		font-size: 24px;
	}

	.gos {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>